$(function() {
    // Usiamo una IIFE (Immediately Invoked Function Expression) per creare uno scope privato.
    (function($) {
        // ############################################
        // ############### PRODUCT ZOOM ###############
        // ############################################

        // --- CACHING DEI SELETTORI STATICI ---
        const $body = $('body');
        const $productZoom = $('.product-zoom');
        const $zoomContainer = $productZoom.find('.zoom-img-container');
        const $zoomCloseBtn = $productZoom.find('.zoom-close');

        // --- SELETTORI DINAMICI ---
        const thumbnailSelector = '[data-zg-role="thumbnail-zoom"]';
        const mainImageSelector = '#zoomMain img';
        const openZoomMobileSelector = '[data-zg-role="zoom-open"]';

        // --- FUNZIONI DI SUPPORTO ---

        function openZoom() {
            $body.addClass('zoom-is-active');
        }

        function closeZoom() {
            $body.removeClass('zoom-is-active');
        }

        function switchImage(imageUrl, $activeThumb) {
            if (!imageUrl) return;
            
            $zoomContainer.css('background-image', 'url(' + imageUrl + ')');

            $(thumbnailSelector).removeClass('selected');
            if ($activeThumb && $activeThumb.length) {
                $activeThumb.addClass('selected');
            }
        }

        // --- GESTIONE DEGLI EVENTI (CON DELEGA) ---

        // 1. Mouse sopra una thumbnail
        $(document).on('mouseover', thumbnailSelector, function() {
            const $this = $(this);
            const imageUrl = $this.attr('data-zoom-images');
            switchImage(imageUrl, $this);
        });

        // 2. Click sull'immagine principale
        $(document).on('click', mainImageSelector, function() {
            const imageUrl = $(this).attr('src');
            const $matchingThumb = $(thumbnailSelector).filter('[data-zoom-images="' + imageUrl + '"]').first();
            
            switchImage(imageUrl, $matchingThumb);
            openZoom();
        });

        // 3. Click sul pulsante di apertura su mobile
        $(document).on('click', openZoomMobileSelector, function() {
            const imageUrl = $(this).attr('data-zoom-images');
            $zoomContainer.css('background-position', 'center center');
            switchImage(imageUrl, null);
            openZoom();
        });

        // 4. Click sul pulsante di chiusura "X"
        $zoomCloseBtn.on('click', function() {
            closeZoom();
        });

        // 5. Movimento del mouse/dito sul contenitore dello zoom
        $zoomContainer.on("mousemove touchmove", function(e) {
            e.preventDefault();

            const containerOffset = $zoomContainer.offset();
            const containerWidth = $zoomContainer.width();
            const containerHeight = $zoomContainer.height();
            const pageX = e.pageX || e.originalEvent.touches[0].pageX;
            const pageY = e.pageY || e.originalEvent.touches[0].pageY;
            const x = pageX - containerOffset.left;
            const y = pageY - containerOffset.top;
            const positionX = Math.min(Math.max((x / containerWidth) * 100, 0), 100);
            const positionY = Math.min(Math.max((y / containerHeight) * 100, 0), 100);

            $zoomContainer.css('background-position', positionX + '% ' + positionY + '%');
        });
        
        // 6. Click sull'immagine zoomata per chiudere (NUOVO)
        $zoomContainer.on('click', function(e) {
            // Chiude lo zoom solo se si clicca direttamente sul contenitore
            // e non su un suo elemento figlio (es. la 'X' o le thumbnail).
            if ($(e.target).is($zoomContainer)) {
                closeZoom();
            }
        });

    })(jQuery);
});